import React from "react";
import { getUser, getUserExpertise } from "../../../services/userService";
import { Alert, CardBody, Container, Card, Row, Col } from "reactstrap";
import NoImage from "../../../assets/images/no_image.png";
import moment from "moment";
import LoadingOverlay from 'react-loading-overlay';
 
import FilePreviewer from 'react-file-previewer';
import {FilePreviewerThumbnail} from 'react-file-previewer';

const style = {
    imagetitle : {"fontSize":"16px", "lineHeight": "24px", "fontWeight":"500"},
    imageWrap: {"overflowX":"auto", "display" :"flex" ,"overFlowY": "auto"},
    imageUpload: {"border": "1px solid #ccc", "display": "inline-flex", "justifyContent":"center", "borderRadius":"8px", "width": "120px", "height": "120px", "cursor":"pointer", "position":"relative"},
    uploadInput: {"position": "absolute", "visibility": "hidden", "height": "0", "width": "0"},
    uploadedImage: {"marginLeft": "12px", "position": "relative", "display": "inline-flex"},
    uploadedImageImg: {"width":"120px", "height":"120ox", "maxHeight": "120px", "borderRadius" :"8px", "objectFit":"contain", "border": "1px solid #e6e6e6"},
    imageDeleteButton : { position: "absolute", right: "8px", color: "#ca2121", top: "8px", "cursor": "pointer" }
}


class AddEditUser extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            user_id: this.props.match.params.id,
            user: {},
            alertModel: false,
            alertMessage: "",
            expertise: {},
            userLoading: false,
            expertiseLoading: false,
        };

        this.loadUser = this.loadUser.bind(this);
    }

    loadUser(id){

        this.setState({
            userLoading: true,
            expertiseLoading: true,
        });
        getUser(id)
        .then(res => {
            this.setState({
                userLoading: false
            });

            console.log(res.data);

            const { data } = res;
            console.log(data);
            if(data.status) {
                this.setState({
                    user: data.user,
                    // expertise: data.expertisesReponse
                });
            } else {
                this.setState({
                    alertModel: true,
                    alertMessage: data.message,
                    alertType: "danger"
                });
            }
        });

        getUserExpertise(id)
        .then(res => {
            this.setState({
                expertiseLoading: false,
            });

            const { data } = res;
            console.log(data);
            if(data.expertisesReponse.wishlist)
            if(data.expertisesReponse.wishlist.length > 0) {

                if(data.expertisesReponse.wishlist[0] && data.expertisesReponse.wishlist[0].name) {
                    this.setState({
                        wishlist_name: data.expertisesReponse.wishlist[0].name
                    });
                }

                if(data.expertisesReponse.wishlist[0] && data.expertisesReponse.wishlist[0].last_name) {
                    this.setState({
                        wishlist_last_name: data.expertisesReponse.wishlist[0].last_name
                    });
                }

                if(data.expertisesReponse.wishlist[0].social && data.expertisesReponse.wishlist[0].social.length > 0){
                    if(data.expertisesReponse.wishlist[0].social.find(x => x.social_name == "Instagram")) {
                        this.setState({ 
                            instagram_link: data.expertisesReponse.wishlist[0].social.find(x => x.social_name == "Instagram").link || "NA",
                        })
                    }
                    if(data.expertisesReponse.wishlist[0].social.find(x => x.social_name == "Twitter")) {
                        this.setState({ 
                            twitter_link: data.expertisesReponse.wishlist[0].social.find(x => x.social_name == "Twitter").link || "NA",
                        })
                    }
                }
            }
            
            if(data.status) {
                this.setState({
                    // user: data.user,
                    expertise: data.expertisesReponse
                });
            } else {
                this.setState({
                    alertModel: true,
                    alertMessage: data.message,
                    alertType: "danger"
                });
            }
        });


    }

    componentDidMount() {
        if(this.props.match.params.id) {
            this.loadUser(this.props.match.params.id);
        }
    }
    
    renderFile(file, index) {
        return(
            <section style={style.uploadedImage} key={index}>
            <img
                 src={file}
                style={style.uploadedImageImg}
                alt={"No Available"}
            />
        </section>

        //     <Card
        //         className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
        //         key={index}
        //     >

        //     <div className="p-2">
        //         <Row className="align-items-center">
        //             <Col lg={10}>
        //                 <a
        //                     href={file}
        //                     download={file.split("Avatars/")[1]}
        //                     className={`text-info font-weight-bold`}
        //                 >
        //                     {file.split("Avatars/")[1]}
        //                 </a>
        //             </Col>
        //         </Row>
        //     </div>
        // </Card>
        )
    }


    render() {

        const { user, expertise } = this.state;

        return (
            <React.Fragment>
                <div className="page-content">

                    <Container fluid>
                        <Alert color={this.state.alertType} isOpen={this.state.alertModel} toggle={this.toggleAlert}>
                            {this.state.alertMessage}
                        </Alert>
                        <LoadingOverlay
                            active={this.state.userLoading || this.state.expertiseLoading }
                            spinner
                            text='Loading User Details'
                        >
                            
                     
                        <Card>
                            <CardBody>
                                <h3>User Details</h3>
                            </CardBody>
                        </Card>
                        <div style={{"maxHeight": "700px", "overflowY":"auto"}} >
                        <Card>
                            <CardBody >
                                
                                <Row className="mt-4">  
                                    <Col lg={4}>
                                        <strong><h3>Basic Deails</h3></strong>
                                    </Col>
                                </Row>
                                
                                <Row className="mt-4">
                                    <Col lg={3} md={6} sm={6} xs={6}>
                                        <strong><h5>Profile Picture</h5></strong>
                                        <img src={user.avatar ?  `${user.avatar}` : NoImage} height="50px" width="50px" alt="No Available" />
                                    </Col>
                                    <Col lg={3} md={6} sm={6} xs={6}>
                                        <strong><h5>First Name:</h5></strong> {user.first_name || "NA"}
                                    </Col>
                                    <Col lg={3} md={6} sm={6} xs={6}>
                                        <strong><h5>Middle Name:</h5></strong>{user.middle_name || "NA"}
                                    </Col>
                                    <Col lg={3} md={6} sm={6} xs={6}>
                                        <strong><h5>Last Name:</h5></strong>{user.last_name || "NA"}
                                    </Col>
                                </Row>
                                <Row className="mt-2">
                                    <Col lg={3} md={6} sm={6} xs={6}>
                                        <strong><h5>User Type:</h5></strong>{user.usertype === 1 ? "Admin" : "User"}
                                    </Col>
                                    <Col lg={3} md={6} sm={6} xs={6}>
                                        <strong><h5>DOB:</h5></strong>{moment(user.DOB).format("DD-MM-YYYY") || "NA"}
                                    </Col>
                                    <Col lg={3} md={6} sm={6} xs={6}>
                                        <strong><h5>Email:</h5></strong>{user.email || "NA"}
                                    </Col>
                                    <Col lg={3} md={6} sm={6} xs={6}>
                                        <strong><h5>Gender:</h5></strong>{user.gender || "NA"}
                                    </Col>
                                </Row>
                                
                                <Row className="mt-2">
                                    <Col lg={3} md={6} sm={6} xs={6}>
                                        <strong><h5>Mobile:</h5></strong>{user.mobile_no || "NA"}
                                    </Col>
                                    <Col lg={3} md={6} sm={6} xs={6}>
                                        <strong><h5>Height(cm):</h5></strong>{user.height || "NA"}
                                    </Col>
                                    <Col lg={3} md={6} sm={6} xs={6}>
                                        <strong><h5>Body:</h5></strong>{user.body_type ? user.body_type.name : "NA"}
                                    </Col>
                                    <Col lg={3} md={6} sm={6} xs={6}>
                                        <strong><h5>Identity:</h5></strong>{user.further_identity ? user.further_identity.name : "NA"}
                                    </Col>
                                </Row>

                                <Row className="mt-2">
                                  
                                    <Col lg={3} md={6} sm={6} xs={6}>
                                        <strong><h5>Job Title:</h5></strong>{user.job_title || "NA"}
                                    </Col>
                                    <Col lg={3} md={6} sm={6} xs={6}>
                                        <strong><h5>Referral Code:</h5></strong>{user.referral_code || "NA"}
                                    </Col>
                                    <Col lg={3} md={6} sm={6} xs={6}>
                                        <strong><h5>Rating Point:</h5></strong>{user.rating_point || 0}
                                    </Col>
                                    <Col lg={3} md={6} sm={6} xs={6}>
                                        <strong><h5>Featured in Hall of Super Sage:</h5></strong>{user.to_be_feature ? "Yes" : "No"}
                                    </Col>
                                </Row>

                                <Row className="mt-4">

                                    <Col lg={3} md={6} sm={6} xs={6}>
                                        <strong><h5>Like to Profile in Hall of Super Sage:</h5></strong>{user.is_like_to_super_sages ? "Yes" : "No"}
                                    </Col>
                                  
                                    <Col lg={4} md={6} sm={6} xs={6}>
                                        <strong><h5>Primary Address:</h5></strong>
                                        {
                                            !user.city_of_primary_residence 
                                            ?
                                                "NA"
                                            :
                                            `${user.city_of_primary_residence},${user.state_of_primary_residence}`
                                        }
                                    </Col>
                                    <Col lg={4} md={6} sm={6} xs={6}>
                                        <strong><h5>Secondary Address:</h5></strong>
                                        {
                                            !user.city_of_secondary_residence 
                                            ?
                                                "NA"
                                            :
                                            `${user.city_of_secondary_residence},${user.state_of_secondary_residence}`
                                        }
                                    </Col>
                                </Row>
                                
                                <hr/>

                                <Row className="mt-4">  
                                    <Col lg={12}>
                                        <strong><h3>Documents and Images</h3></strong>
                                    </Col>
                                </Row>
                                <Row className="mt-4">  
                                    <Col lg={6} md={6} sm={6} xs={6}>
                                        <strong><h5>Document:</h5></strong>
                                        {
                                            user.document && user.document !== "null" 
                                            ? 
                                                <Card
                                                        className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                                        
                                                    >
                                        
                                                    <div className="p-2">
                                                        <Row className="align-items-center">
                                                            <Col lg={10}>
                                                                <a
                                                                    href={user.document}
                                                                    download={user.document.split("Avatars/")[1]}
                                                                    className={`text-info font-weight-bold`}
                                                                >
                                                                    {user.document.split(`user${this.state.user.user_id}/`)[1]}
                                                                </a>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </Card>
                                            : <Col lg={12}><span className="text-danger">Document not Uploaded </span></Col>
                                            }
                                    </Col>
                                    <Col lg={6} md={6} sm={6} xs={6}>
                                        <strong><h5>Gallery Images:</h5></strong>
                                        <section style={style.imageWrap}>
                                        {
                                            user.galleryImages && user.galleryImages.length 
                                            ?  
                                                user.galleryImages.map((x, i) => this.renderFile(x, i)) 
                                            : 
                                            <Col lg={12}><span className="text-danger">No Image Uploaded</span></Col>
                                        }
                                        </section>
                                    </Col>
                                </Row>

                                <hr/>

                                <Row className="mt-4">  
                                    <Col lg={4}>
                                        <strong><h3>Social Media Handle</h3></strong>
                                    </Col>
                                </Row>

                                <Row className="mt-4">
                                    <Col lg={3} md={6} sm={6} xs={6}>
                                        <strong><h5>Instagram:</h5></strong>
                                        {user.instagram_link || "NA"}
                                    </Col>
                                    <Col lg={3} md={6} sm={6} xs={6}>
                                        <strong><h5>Books:</h5></strong>
                                        {user.books_link || "NA"}
                                    </Col>
                                    <Col lg={3} md={6} sm={6} xs={6}>
                                        <strong><h5>Ecommerce:</h5></strong>
                                        {user.Ecommerce_link || "NA"}
                                    </Col>
                                    <Col lg={3} md={6} sm={6} xs={6}>
                                        <strong><h5>Blog:</h5></strong>
                                        {user.blog_link || "NA"}
                                    </Col>
                                </Row>
                                <Row className="mt-4">
                                    <Col lg={3} md={6} sm={6} xs={6}>
                                        <strong><h5>Twitter:</h5></strong>
                                        {user.twitter_link || "NA"}
                                    </Col>
                                    <Col lg={3} md={6} sm={6} xs={6}>
                                        <strong><h5>Website:</h5></strong>
                                        {user.website_link || "NA"}
                                    </Col>
                                    <Col lg={3} md={6} sm={6} xs={6}>
                                        <strong><h5>Youtube:</h5></strong>
                                        {user.youtube_ink || "NA"}
                                    </Col>
                                    <Col lg={3} md={6} sm={6} xs={6}>
                                        <strong><h5>Social Media:</h5></strong>
                                        {user.social_media_link || "NA"}
                                    </Col>
                                </Row>
                                <Row className="mt-4">
                                    <Col lg={3} md={6} sm={6} xs={6}>
                                        <strong><h5>Podcast:</h5></strong>
                                        {user.podcast_link || "NA"}
                                    </Col>
                                    <Col lg={3} md={6} sm={6} xs={6}>
                                        <strong><h5>Music:</h5></strong>
                                        {user.music_link || "NA"}
                                    </Col>
                                </Row>

                                <hr/>
                                <Row className="mt-4">
                                    <Col lg={6}>
                                    <strong><h5>Colleges and University</h5></strong>
                                    </Col>
                                    <Col lg={6} md={6} sm={6} xs={6}>
                                        <strong><h5>Degree:</h5></strong>{user.academic_degree ? user.academic_degree.name : "NA"}
                                    </Col>
                                </Row>
                                <Row>
                                  
                                        {
                                        user.college && user.college.length > 0  
                                        ?
                                            user.college.map((x,i) => 
                                                <Col lg={3} md={3} sm={6} xs={6} key={i}>
                                                    <Card>
                                                        <CardBody>
                                                            <Row>
                                                                <Col lg="9"> { x.name}</Col>
                                                            </Row>
                                                        </CardBody>
                                                    </Card>
                                                </Col>
                                            )
                                        : 
                                            <Col lg={12}><span className="text-danger">No college added yet</span></Col>
                                    }
                                </Row>
                                <hr/>
                                <Row className="mt-4">
                                    <Col lg={12}>
                                        <strong><h3>Languages</h3></strong>
                                    </Col>
                                    {
                                        user.language && user.language.length
                                        
                                        ?
                                            user.language.map((x,i) => 
                                                <Col lg={3} md={3} sm={6} xs={6} key={i}>
                                                    <Card>
                                                        <CardBody>
                                                            <Row>
                                                                <Col lg="9"> { x.name}</Col>
                                                            </Row>
                                                        </CardBody>
                                                    </Card>
                                                </Col>
                                            )   
                                        : <Col lg={12}><span className="text-danger">No Language added yet</span> </Col>
                                    }
                                </Row>
                                <hr/>
                                <Row className="mt-4">
                                    <Col lg={12}>
                                        <strong><h3>Interest and Search Criteria</h3></strong>
                                    </Col>
                                </Row>
                                <Row className="mt-4">
                                    <Col lg={12}>
                                        <strong><h4>Expertise</h4></strong>
                                    </Col>
                                    {
                                        expertise.expertise && expertise.expertise.length> 0
                                        ? expertise.expertise.map((x,i) => 
                                            <Col lg={3} md={3} sm={6} xs={6} key={i}>
                                                <Card>
                                                    <CardBody>
                                                        <Row>
                                                            <p> <strong>Expertise: </strong> {x['expertise_name'] || "NA"} </p>
                                                        </Row>
                                                        <Row>
                                                            <p> <strong> Sub Expertise:</strong> {x['sub_expertise_name'] || "NA"} </p>
                                                        </Row>
                                                    </CardBody>
                                                </Card>
                                            </Col>
                                            )   
                                        :   <Col lg={12}><span className="text-danger">Not Added yet</span></Col>
                                    }
                                    <Col lg={12}> 
                                        <p> <strong><h4>Other Expertise:</h4> </strong> {expertise.other_expertise || "NA"} </p>
                                    </Col>
                                </Row>
                                {/* <hr/> */}
                                <Row className="mt-4">
                                    <Col lg={12}>
                                        <strong><h4>Topics</h4></strong>
                                    </Col>
                                    {
                                        expertise.topic && expertise.topic.length> 0
                                        ?
                                        expertise.topic.map((x,i) => 
                                        <Col lg={3} md={3} sm={6} xs={6} key={i}>
                                            <Card>
                                                <CardBody>
                                                    <Row>
                                                        <p> <strong>Topic: </strong> {x['topic_name'] || "NA"} </p>
                                                        {/* <Col lg="9"> { x.name}</Col> */}
                                                    </Row>
                                                    <Row>
                                                        <p> <strong> Sub Tpoic:</strong> {x['sub_topic_name'] || "NA"} </p>
                                                    </Row>
                                                </CardBody>
                                            </Card>
                                        </Col>
                                        )  : <Col lg={12}><span className="text-danger">Not Added yet</span></Col>  
                                    }
                                    <Col lg={12}> 
                                        <p> <strong><h4>Other Topic: </h4> </strong> {expertise.other_topic || "NA"} </p>
                                    </Col>
                                </Row>

                                <Row className="mt-4">
                                    <Col lg={12}>
                                        <strong><h4>Interests</h4></strong>
                                    </Col>
                                    {
                                        expertise.interest && expertise.interest.length > 0 
                                        ?
                                        expertise.interest.map((x,i) => 
                                        <Col lg={3} md={3} sm={6} xs={6} key={i}>
                                            <Card>
                                                <CardBody>
                                                    {/* <Row> */}

                                                        <p> <strong>{x["name"]}</strong></p>
                                                    {/* </Row> */}
                                                </CardBody>
                                            </Card>
                                        </Col>
                                        ) : <Col lg={12}><span className="text-danger">Not Added yet</span></Col>    
                                    }
                                </Row>

                                <Row>
                                    <Col lg={4}  md={6} sm={6} xs={6}>
                                        <strong><h5>Converse With: </h5></strong> {expertise.converse_with || "NA"}
                                    </Col>

                                    <Col lg={4}  md={6} sm={6} xs={6}>
                                        <strong><h5> Age Range: </h5></strong> {expertise.age_range ? `${expertise.age_range.split(";")[0]} - ${expertise.age_range.split(";")[1]}`: "NA"}
                                    </Col>

                                    <Col lg={4}  md={6} sm={6} xs={6}>
                                        <strong><h5>Body Type:</h5></strong> {expertise.body_type ? (expertise.body_type.name || "NA" ) : "NA"}
                                    </Col>
                                </Row>

                                <Row className="mt-2">
                                    <Col lg={4}  md={6} sm={6} xs={6}>
                                        <strong><h5>No Distance Limit within country:</h5></strong> {expertise.distance_limited_by_country ? "Yes" : "No"}
                                    </Col>

                                    <Col lg={4}  md={6} sm={6} xs={6}>
                                        <strong><h5>Maxiumu Distance (miles):</h5></strong> {expertise.maximum_distance || 0}
                                    </Col> 

                                    {/* <Col lg={3}>
                                        <strong>Twitter Link: { expertise.wish_lits && expertise.wish_lits.social.find(x => )}</strong>
                                    </Col> */}
                                </Row>

                                <Row className="mt-4">
                                    <Col lg={12}>
                                        <strong><h4>Wishlist</h4></strong>
                                    </Col>
                                        {/* { */}
                                            {/* // expertise.wishlist && expertise.wishlist[0].social[0] ?
                                                // expertise.wish_lits[0].social.map((x,i) =>  */}
                                                <>
                                                <Col lg={3} md={3} sm={6} xs={6}>
                                                    <strong><h5>First Name:</h5></strong> {this.state.wishlist_name || "NA"}
                                                </Col>
                                                <Col lg={3} md={3} sm={6} xs={6}>
                                                    <strong><h5>Last Name:</h5></strong> {this.state.wishlist_last_name || "NA"}
                                                </Col>
                                                {/* {expertise.wishlist[0].social && expertise.wishlist[0].social[0].isSelect &&  */}
                                                    <Col lg={3} md={3} sm={6} xs={6}>
                                                        <Card>
                                                            <CardBody>
                                                                <span>
                                                                    <i className="fab fa-instagram"></i>
                                                                    <strong className="ml-2"> {this.state.instagram_link || "NA"}</strong>
                                                                </span>
                                                            
                                                            </CardBody>
                                                        </Card>
                                                    </Col>
                                                {/* // } */}
                                                {/* {expertise.wishlist[0].social[1] && expertise.wishlist[0].social[1].isSelect && */}
                                                    <Col lg={3} md={3} sm={6} xs={6}>
                                                        <Card>
                                                            <CardBody>
                                                                <span><i className="fab fa-twitter"></i>
                                                                <strong className="ml-2">{ this.state.twitter_link || "NA"}</strong></span>
                                                            </CardBody>
                                                        </Card>
                                                    </Col>
                                                {/* } */}
                                            </>
                                             {/* )    */}
                                    {/* //     : <Col lg={12}><span className="text-danger">Not Added yet</span></Col>
                                    // } */}
                                </Row>


                            </CardBody>
                        </Card> 
                        </div>

                      

                        </LoadingOverlay>
                    </Container>


                </div>
            </React.Fragment>
        )
    }
}

export default AddEditUser;